"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guid = void 0;
var table = {};
var s = function () { return Math
    .floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1); };
var uuid = function () { return s() + '-' + s() + '-' + s() + '-' + s(); };
var guid = function () {
    var u = uuid();
    while (table[u]) {
        u = uuid();
    }
    table[u] = true;
    return u;
};
exports.guid = guid;
//# sourceMappingURL=guid.js.map